import React, {Component, PureComponent} from "react";
import LeagueItem from "./LeagueItem";

class Leagues extends PureComponent {

	render() {
		const {leagues} = this.props.data;

		if (!leagues) return <div></div>;

		const all_leagues = leagues.filter((league) => { return parseInt(league.type) === 0}).map((league) => {
			return (
				<LeagueItem league={league} selectLeague={this.props.selectLeague} />
			);
		});

		const all_long_leagues = leagues.filter((league) => { return parseInt(league.type) === 1}).map((league) => {
			return (
				<LeagueItem league={league} selectLeague={this.props.selectLeague} />
			);
		});

		return (
			<ul className="event-list__sub-leagues leagues">
				{all_leagues}

				{all_long_leagues.length > 0 && <li className="long-caption"><span>Долгосрочные</span></li>}
				{all_long_leagues}
			</ul>
		)
	}
}

export default Leagues;


// WEBPACK FOOTER //
// ./src/app/components/LineWidget/Leagues.js